export default __webpack_public_path__ + "static/media/gallery_01.599837f5.jpg";